import { render, staticRenderFns } from "./TopBarLayoutsButton.vue?vue&type=template&id=69d208bd&scoped=true&"
import script from "./TopBarLayoutsButton.vue?vue&type=script&lang=js&"
export * from "./TopBarLayoutsButton.vue?vue&type=script&lang=js&"
import style0 from "./TopBarLayoutsButton.vue?vue&type=style&index=0&id=69d208bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d208bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d208bd')) {
      api.createRecord('69d208bd', component.options)
    } else {
      api.reload('69d208bd', component.options)
    }
    module.hot.accept("./TopBarLayoutsButton.vue?vue&type=template&id=69d208bd&scoped=true&", function () {
      api.rerender('69d208bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TopBarLayoutsButton.vue"
export default component.exports